import { Constants } from '@constants';
import { Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

export const ErrorMessage = () => (
    <Text className="mt-m text-m font-reg text-error">
        <FormattedMessage
            id="_.credit_card.dashboard.actions.error"
            defaultMessage="Failed to process card replacement. Please call us on <a>{phone}</a>."
            values={{
                phone: Constants.CREDIT_CARD_PHONE_NUMBER.display,
                a: (chunks) => (
                    <a href={`tel:${Constants.CREDIT_CARD_PHONE_NUMBER.tel}`}>
                        <strong>{chunks}</strong>
                    </a>
                )
            }}
        />
    </Text>
);
